export default "__VITE_ASSET__B987A0G9__"